<template>
  <v-container fluid>
    <div class="d-block d-md-flex">
      <AppAside></AppAside>
      <div class="ps-5 page_content grow">
        <LogsTable></LogsTable>
      </div>
    </div>
  </v-container>
</template>

<script>
import LogsTable from "@/components/orders/LogsTable";

export default {
  name: "products_page",
  data() {
    return {
      form: false,
    };
  },
  components: {
    LogsTable,

  },
};
</script>
